import { render, staticRenderFns } from "./GameSelectAvatar.vue?vue&type=template&id=58989a8a&scoped=true&"
import script from "./GameSelectAvatar.vue?vue&type=script&lang=js&"
export * from "./GameSelectAvatar.vue?vue&type=script&lang=js&"
import style0 from "./GameSelectAvatar.vue?vue&type=style&index=0&id=58989a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58989a8a",
  null
  
)

export default component.exports